export const getLoading = (state) => state.isLoading;

export const getCtaDisabled = (state) => state.isCtaDisabled;

export const getSelectedAccount = (state) => state.selectedAccount;

export const getSaveForLater = (state) => state.saveForLater;

export const getEditing = (state) => state.editing;
